module.exports = __webpack_public_path__ + "media/images/lp/lp10-58ca65be6a29f304e3f736f5bb60e245.webp";